import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as moment from 'moment';
import { UploadDAO } from '../../../../../../../core/services/dao/uploadDAO';
import { NumberFormatterService } from '../../../../../../../core/services/number.formatter.service';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { DialogsService } from '../../../../../../../core/services/dialog.service';
import { VesselRateDAO } from '../../../../../../../core/services/dao/vesselRateDAO';
import {
  RatePayee,
  VesselRate,
} from 'anchor-shared/lib/model/entity/vessel-rate';
import { VesselRateCalculationService } from '../../../../../../../core/services/vessel-rate-calculation-service';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PayeeSelectionResult } from '../../../../../../shared/payouts/payee-selection/payee-selection.component';
import { AddEditVesselRateDialogComponent } from './add-edit-vessel-rate-dialog/add-edit-vessel-rate-dialog.component';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';
import { NameEditButtonComponent } from './line-item-actions/nameEditButton/nameEditButton.component';
import { DeleteButtonComponent } from './line-item-actions/deleteButton/deleteButton.component';
import { CustomPriceComponent } from './line-item-actions/customPrice/customPrice.component';
import { hasSplitsButtonComponent } from './line-item-actions/hasSplitsButton/nameEditButton.component';
import { AddEditVesselRatePerHourDialogComponent } from './add-edit-vessel-rate-per-hour-dialog/add-edit-vessel-rate-per-hour-dialog.component';
import {
  ScreenType,
  WhatsIncluded,
} from 'anchor-shared/lib/model/interface/add-edit-vessel-rate-per-hour-dialog-data';
import { getRateNameForCustomer } from 'anchor-shared/lib/service/pure-functions/get-vessel-rate-name';
import { buildRouteEnding } from '../../../../../../../core/pure-functions/navigation/buyflow-vessel-route-builder/buyflow-vessel-route-builder';
import { EnvironmentalMediaService } from '../../../../../../../core/services/environmental-media.service';
import { UserDAO } from '../../../../../../../core/services/dao/userDAO';
import { AddOnDAO } from '../../../../../../../core/services/dao/addOnDAO';
import { AddOn, DefinedAddOnType } from 'anchor-shared/lib/model/entity/addOn';
import { roundToNearestCent } from 'anchor-shared/lib/service/utils/helper';

@Component({
  selector: 'app-services-and-pricing-form',
  templateUrl: './services-and-pricing.component.html',
  styleUrls: ['./services-and-pricing.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ServicesAndPricingFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public getRateNameForCustomer = getRateNameForCustomer;
  linkToListingPage: string;
  @Input() model: Vessel;
  @Input() disabled: boolean;
  @Input() isAdmin: boolean;

  @Output()
  saveVessel = new EventEmitter();

  ScreenType = ScreenType;
  DefinedAddOnType = DefinedAddOnType;

  subs: Subscription[] = [];

  charterLOS = false;
  currencyMask: any;
  percentageMask: any;
  halfDayTotal: number;
  fullDayTotal: number;
  additionalHoursTotal: number;
  rates: VesselRate[];
  depositAmount: number;
  fuelRateType: RateType;
  ownerRateType: RateType;
  columnDefs: any;
  rowData = [];
  halfDayRetailPrice: number;
  fullDayRetailPrice: number;
  hourlyRetailPrice: number;
  listGridHeight: string = '132px';
  captainRates: VesselRate[] = [];
  captainRatesText: string = 'Not included';
  crewRates: VesselRate[] = [];
  crewRatesText: string = 'Not included';
  fuelRates: VesselRate[] = [];
  fuelRatesText: string = 'Not included';
  taxRates: VesselRate[] = [];
  taxAmount: number = 0;
  cleaningRates: VesselRate[] = [];
  cleaningFeeHr: number = 0;
  cleaningRateText;
  isMobile: boolean;
  fuelPayee: string;
  addOns: AddOn[] = [];
  optionalAddOns: AddOn[] = [];
  extraGuestAddOn: AddOn;

  constructor(
    private uploadDAO: UploadDAO,
    private numberFormatterService: NumberFormatterService,
    public dialog: DialogsService,
    private vesselRateDAO: VesselRateDAO,
    private vesselRateCalculationService: VesselRateCalculationService,
    private vesselDAO: VesselDAO,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private environmentalMediaService: EnvironmentalMediaService,
    private userDao: UserDAO,
    private addOnDAO: AddOnDAO,
  ) {
    this.currencyMask = this.numberFormatterService.createPriceMask();
    this.percentageMask = this.numberFormatterService.createPercentageMask();
    this.fuelRateType = RateType.FuelIncluded;
    this.ownerRateType = RateType.Owner;
  }

  ngOnInit() {
    this.isMobile = window && window.screen && window.screen.width < 960;
    if (this.model.halfDayListPrice) {
      this.halfDayTotal = this.model.halfDayListPrice;
    } else {
      this.halfDayTotal = this.model.halfDayPrice;
    }
    if (this.model.fullDayListPrice) {
      this.fullDayTotal = this.model.fullDayListPrice;
    } else {
      this.fullDayTotal = this.model.fullDayPrice;
    }
    if (this.model.additionalHoursListPrice) {
      this.additionalHoursTotal = this.model.additionalHoursListPrice;
    } else {
      this.additionalHoursTotal = this.model.additionalHours;
    }
    this.depositAmount = this.model.depositAmount;
    this.loadRates();
    this.getAddOns();
    this.linkToListingPage = this.createLinkToListingPage();
    // this.buildTotals();
    if (this.model.fuelPayeeUserId) {
      this.getFuelPayeeUser();
    }
  }

  separateRatesByType() {
    this.captainRates = [];
    this.captainRatesText = 'Not included';
    this.crewRates = [];
    this.crewRatesText = 'Not included';
    this.fuelRates = [];
    this.fuelRatesText = 'Not included';
    this.taxRates = [];
    this.taxAmount = 0;
    this.cleaningRates = [];
    this.cleaningFeeHr = 0;
    this.cleaningRateText = null;

    this.captainRates = this.rates.filter(
      (rate) => rate.rateType === RateType.Captain,
    );
    this.crewRates = this.rates.filter(
      (rate) => rate.rateType === RateType.Crew,
    );
    this.fuelRates = this.rates.filter(
      (rate) => rate.rateType === RateType.FuelIncluded,
    );
    this.taxRates = this.rates.filter((rate) => rate.taxPercentage > 0);
    this.cleaningRates = this.rates.filter(
      (rate) => rate.rateType === RateType.Cleaning,
    );
    let highestCaptainRate = 0;
    this.captainRates.map((rate) => {
      if (rate.hourlyRate > highestCaptainRate) {
        this.captainRatesText = `$${rate.hourlyRate}/hr each`;
      }
    });
    let highestCrewRate = 0;
    this.crewRates.map((rate) => {
      if (rate.hourlyRate > highestCrewRate) {
        this.crewRatesText = `$${rate.hourlyRate}/hr each`;
      }
    });
    let highestFuelRate = 0;
    this.fuelRates.map((rate) => {
      if (rate.hourlyRate >= highestFuelRate) {
        this.fuelRatesText = `$${rate.hourlyRate}/hr`;
      }
    });
    let highestTaxAmount = (this.taxAmount = 0);
    this.taxRates.map((rate) => {
      if (highestTaxAmount < rate.taxPercentage) {
        this.taxAmount = parseFloat((rate.taxPercentage * 100).toFixed(2));
      }
    });
    this.cleaningRates.map((rate) => {
      this.cleaningRateText = `$${(
        rate.customRate *
        (rate.markupPercentage + 1)
      ).toFixed(2)} per trip`;
    });
  }

  loadRates(isEdit: boolean = false) {
    const ratesSub = this.vesselRateDAO
      .getByVesselId(this.model.id)
      .subscribe((rates) => {
        this.addRates(rates, isEdit);
      });
    this.subs.push(ratesSub);
  }

  addBasicRate(rate: VesselRate): number {
    if (
      rate.rateType === RateType.Captain ||
      rate.rateType === RateType.Crew ||
      rate.rateType === RateType.FuelIncluded ||
      rate.rateType === RateType.Owner
    ) {
      return parseFloat(
        (rate.hourlyRate * (1 + rate.markupPercentage)).toFixed(2),
      );
    } else {
      return 0;
    }
  }

  addRates(rates: VesselRate[], isEdit?: boolean) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    this.adjustListGridHeight(rates);
    this.rates = rates;
    this.separateRatesByType();
    this.model.hourlyRate = 0;
    this.rates.map((rate) => {
      this.model.hourlyRate += this.addBasicRate(rate);
      this.rowData.push({
        ...rate,
        displayName: this.getRateNameForCustomer(rate),
        halfDayRateFormatted: rate.customRate
          ? formatter.format(rate.customRate)
          : formatter.format(rate.halfDayRate),
        fullDayRateFormatted: rate.customRate
          ? ''
          : formatter.format(rate.fullDayRate),
        hourlyRateFormatted: rate.customRate
          ? ''
          : formatter.format(rate.hourlyRate),
        formattedTaxPercentage:
          rate.taxPercentage > 0
            ? parseFloat((rate.taxPercentage * 100).toFixed(2)) + '%'
            : 'No',
      });
      if (!this.isAdmin && rate.rateType === RateType.BookingFee) {
        this.rowData.pop();
      }
    });
    this.model.hourlyRate = parseInt(this.model.hourlyRate.toFixed(0));
    this.calculateTotal();
    this.columnDefsInit();
    if (isEdit) {
      this.buildTotals();
      this.separateRatesByType();
    }
  }

  getAddOns() {
    this.addOnDAO.getAddOnByVesselId(this.model.id).subscribe((addOns) => {
      this.addOns = addOns;
      this.filterAddOns(this.addOns);
    });
  }

  filterAddOns(addOns) {
    this.optionalAddOns = addOns.filter((x) => !x.required);
    this.extraGuestAddOn = addOns.find(
      (x) => x.name === DefinedAddOnType.EXTRA_GUEST_FEE,
    );
  }

  calculateTotal(): void {
    this.halfDayRetailPrice = 0;
    this.fullDayRetailPrice = 0;
    this.hourlyRetailPrice = 0;

    if (this.rates && this.rates.length) {
      this.rates.forEach((rate) => {
        if (rate.customRate) {
          this.halfDayRetailPrice += rate.customRate;
          this.fullDayRetailPrice += rate.customRate;
        } else {
          this.halfDayRetailPrice += rate.halfDayRate;
          this.halfDayRetailPrice += rate.halfDayRate * rate.markupPercentage;
          this.halfDayRetailPrice +=
            (rate.halfDayRate + rate.halfDayRate * rate.markupPercentage) *
            rate.taxPercentage;

          this.fullDayRetailPrice += rate.fullDayRate;
          this.fullDayRetailPrice += rate.fullDayRate * rate.markupPercentage;
          this.fullDayRetailPrice +=
            (rate.fullDayRate + rate.fullDayRate * rate.markupPercentage) *
            rate.taxPercentage;

          this.hourlyRetailPrice += rate.hourlyRate;
          this.hourlyRetailPrice += rate.hourlyRate * rate.markupPercentage;
          this.hourlyRetailPrice +=
            (rate.hourlyRate + rate.hourlyRate * rate.markupPercentage) *
            rate.taxPercentage;
        }
      });
    }
  }

  columnDefsInit() {
    this.columnDefs = [
      {
        headerName: 'Name',
        field: 'displayName',
        width: 300,
        filter: 'text',
        suppressMenu: true,
        cellRendererFramework: NameEditButtonComponent,
        suppressSizeToFit: true,
      },
      {
        headerName: 'Half Day',
        field: 'halfDayRateFormatted',
        width: 40,
        filter: 'text',
        cellClass: 'grid-text',
        cellRendererFramework: CustomPriceComponent,
      },
      {
        headerName: 'Full Day',
        field: 'fullDayRateFormatted',
        width: 40,
        filter: 'text',
        cellClass: 'grid-text',
      },
      {
        headerName: 'Hourly',
        field: 'hourlyRateFormatted',
        width: 40,
        filter: 'text',
        cellClass: 'grid-text',
      },
      {
        headerName: 'Tax',
        field: 'formattedTaxPercentage',
        width: 40,
        filter: 'text',
        cellClass: 'grid-text',
      },
      {
        headerName: 'Split',
        field: '',
        width: 40,
        filter: 'text',
        cellClass: 'grid-text',
        cellRendererFramework: hasSplitsButtonComponent,
      },
      {
        headerName: '',
        field: '',
        width: 120,
        filter: 'text',
        cellClass: 'grid-text',
        cellRendererFramework: DeleteButtonComponent,
      },
    ];
  }

  publishListPrice(): void {
    this.unMaskPrices();
    this.model.halfDayListPrice = this.halfDayTotal;
    this.model.fullDayListPrice = this.fullDayTotal;
    this.model.additionalHoursListPrice = this.additionalHoursTotal;
    this.vesselDAO
      .publishListPrice(
        this.model.id,
        this.halfDayTotal,
        this.fullDayTotal,
        this.additionalHoursTotal,
      )
      .subscribe((listPriceUpdateResult) => {
        if (listPriceUpdateResult) {
          this.openSnackbar('List Price Updated');
          this.separateRatesByType();
          this.saveVessel.emit();
        }
      });
  }

  adjustListGridHeight(rates) {
    this.listGridHeight = `${rates.length * 100 + 33}px`;
  }

  addNewPricingItem(defaultRateType?: RateType, split?: Boolean): void {
    const vesselRate: Partial<VesselRate> = {
      vesselId: null,
      customRate: 0,
      taxPercentage: 0,
      hourlyRate: 0,
      fullDayRate: 0,
      halfDayRate: 0,
      rateType: null,
      markupPercentage: 0.15,
      name: null,
      ratePayee: null,
      payToUserId: null,
      percentageBasedRatePercent: 0,
      vesselSplitRates: [],
    };

    const dialogSub = this.matDialog
      .open(AddEditVesselRateDialogComponent, {
        data: {
          vesselRate: vesselRate,
          vesselId: this.model.id,
          defaultRateType: defaultRateType,
          halfDayTotal: this.halfDayTotal,
          fullDayTotal: this.fullDayTotal,
          halfDayRetailPrice: this.halfDayRetailPrice,
          fullDayRetailPrice: this.fullDayRetailPrice,
          hourlyRetailPrice: this.hourlyRetailPrice,
          hourlyTotal: this.additionalHoursTotal,
          newSplit: split,
          isAdmin: this.isAdmin,
        },
        panelClass: 'add-edit-vessel-rate-dialog',
      })
      .afterClosed()
      .subscribe((createdVesselRate) => {
        if (createdVesselRate) {
          this.columnDefs = null;
          this.rowData = [];
          this.loadRates(true);
          this.calculateTotal();
          if (createdVesselRate.rateType === RateType.FuelIncluded) {
            this.saveVessel.emit();
          }
        } else {
          if (defaultRateType === RateType.FuelIncluded) {
            this.model.fuelIncluded = false;
          }
        }
      });

    this.subs.push(dialogSub);
  }

  onAction($event) {
    if ($event.type === 'editRate') {
      this.editRate($event.data);
    } else if ($event.type === 'deleteRate') {
      this.deleteClick($event.data);
    } else if ($event.type === 'openSplitRate') {
      this.editRate($event.data);
    }
  }

  editRate(rateModel: VesselRate): void {
    this.matDialog
      .open(AddEditVesselRateDialogComponent, {
        data: {
          vesselRate: rateModel,
          vesselId: this.model.id,
          halfDayTotal: this.halfDayTotal,
          fullDayTotal: this.fullDayTotal,
          hourlyTotal: this.additionalHoursTotal,
          halfDayRetailPrice: this.halfDayRetailPrice,
          fullDayRetailPrice: this.fullDayRetailPrice,
          hourlyRetailPrice: this.hourlyRetailPrice,
          isAdmin: this.isAdmin,
        },
        panelClass: 'add-edit-vessel-rate-dialog',
      })
      .afterClosed()
      .subscribe((updatedVesselRate: VesselRate) => {
        if (updatedVesselRate) {
          this.columnDefs = null;
          this.rowData = [];
          this.loadRates(true);
          this.calculateTotal();
        } else {
          rateModel.markupPercentage = rateModel.markupPercentage / 100;
          rateModel.taxPercentage = rateModel.taxPercentage / 100;
        }
      });
  }

  deleteClick(vesselRate: VesselRate): void {
    const deleteSub = this.vesselRateDAO
      .serverDelete(vesselRate)
      .subscribe((data) => {
        this.columnDefs = null;
        this.rowData = [];
        this.loadRates(true);
      });
    this.subs.push(deleteSub);
  }

  showPricing(): boolean {
    return this.isAdmin || this.model.status === 'active';
  }

  buildTotals(): void {
    this.halfDayTotal = this.vesselRateCalculationService.getListPrice(
      this.rates,
      4,
    );
    this.fullDayTotal = this.vesselRateCalculationService.getListPrice(
      this.rates,
      8,
    );
    this.additionalHoursTotal = this.vesselRateCalculationService.getListPrice(
      this.rates,
      1,
    );

    this.publishListPrice();
  }

  uploadAgreement(event) {
    const file = event.target.files[0];
    this.uploadDAO.uploadFile(file, file.name).subscribe((data) => {
      this.model.charterAgreementUrl = data.filepath;
      this.model.charterAgreementUploadDate = new Date();
    });
  }

  formatDate(date: any) {
    return moment(date).format('MM/DD/YYYY');
  }

  formatUrl(url: string): string {
    const tempArr = url.split('/');
    return tempArr[tempArr.length - 1];
  }

  fuelIncludedSelectionChange(): void {
    if (!this.model.fuelIncluded) {
      this.saveVessel.emit();
      const rateForDeletion =
        this.vesselRateCalculationService.getFuelIncludedRate(
          this.model.vesselRates,
        );
      if (rateForDeletion) {
        this.vesselRateDAO
          .serverDelete(rateForDeletion)
          .subscribe((deleted) => {});
      }
    }
  }

  payeeSelectionMade(payeeSelectionResult: PayeeSelectionResult): void {
    this.model.fuelPayeeType = payeeSelectionResult.payeeType;
    if (payeeSelectionResult.user) {
      this.model.fuelPayeeUserId = payeeSelectionResult.user.id;
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  private unMaskPrices(): void {
    this.halfDayTotal = this.numberFormatterService.unMaskPrice(
      this.halfDayTotal,
    );
    this.fullDayTotal = this.numberFormatterService.unMaskPrice(
      this.fullDayTotal,
    );
    this.additionalHoursTotal = this.numberFormatterService.unMaskPrice(
      this.additionalHoursTotal,
    );
  }

  editBasic(screenType: ScreenType, idx?: number): void {
    let vessel = this.model;
    let addOn = null;
    if (this.model.hourlyRate <= 0) {
      vessel.hourlyRate = 500;
    }
    if (ScreenType.OPTIONAL_ADD_ON === screenType) {
      addOn = idx != null ? { ...this.addOns[idx] } : null;
    } else if (ScreenType.EXTRA_GUEST_FEE === screenType) {
      addOn = this.extraGuestAddOn ? { ...this.extraGuestAddOn } : null;
    }

    const config: any = {
      data: {
        screenType: screenType,
        vesselId: this.model.id,
        isAdmin: this.isAdmin,
        vessel: vessel,
        captainRates: this.captainRates,
        crewRates: this.crewRates,
        fuelRates: this.fuelRates,
        taxRates: this.taxRates,
        taxAmount: this.taxAmount,
        cleaningRates: this.cleaningRates,
        addOn,
        isMobile: this.isMobile,
      },
      autoFocus: false,
      panelClass: 'add-edit-per-hour-dialog-container',
    };
    if (this.isMobile) {
      config.maxWidth = '100vw';
      config.height = '100vh';
      config.width = '100%';
      config.hasBackdrop = true;
    }
    const dialogSub = this.matDialog
      .open(AddEditVesselRatePerHourDialogComponent, config)
      .afterClosed()
      .subscribe((updates) => {
        console.log('updates', updates);
        if (!updates) return;
        switch (updates.screenType) {
          case ScreenType.DEPOSIT:
            this.model.depositAmount = updates.vesselUpdates.depositAmount;
            this.saveVessel.emit();
            break;
          case ScreenType.WHATS_INCLUDED:
            this.model.hourlyRate = updates.vesselUpdates.hourlyRate;
            this.model.fuelIncluded = updates.vesselUpdates.fuelIncluded;
            this.addNewVesselRates(updates);
            this.model.fuelPayeeType = updates.vesselUpdates.fuelPayeeType;
            this.model.fuelPayeeUserId = updates.vesselUpdates.fuelPayeeUserId;
            this.getFuelPayeeUser();
            this.saveVessel.emit();
            break;
          case ScreenType.FUEL_NOT_INCLUDED:
            this.model.hourlyRate = updates.vesselUpdates.hourlyRate;
            this.model.fuelIncluded = updates.vesselUpdates.fuelIncluded;
            this.model.fuelReimbursementRate =
              updates.vesselUpdates.fuelReimbursementRate;
            this.model.fuelBillingRate = updates.vesselUpdates.fuelBillingRate;
            this.model.fuelPayeeType = RatePayee.BOAT_OWNER;
            if (updates.vesselUpdates.fuelNotIncludedOnly) {
              this.deleteFuelRate();
            } else {
              this.addNewVesselRates(updates);
            }
            break;
          case ScreenType.APPLY_TAXES:
            this.applyTaxToRates(updates);
            break;
          case ScreenType.SELECT_TEXES:
            this.applyTaxToRates(updates);
            break;
          case ScreenType.CLEANING_FEE:
            this.addRemoveCleaning(updates);
            this.saveVessel.emit();
            break;
          case ScreenType.SELECT_PAYEE:
            this.model.hourlyRate = updates.vesselUpdates.hourlyRate;
            this.model.fuelIncluded = updates.vesselUpdates.fuelIncluded;
            this.model.fuelReimbursementRate =
              updates.vesselUpdates.fuelReimbursementRate;
            this.model.fuelBillingRate = updates.vesselUpdates.fuelBillingRate;
            if (updates.vesselUpdates.fuelNotIncludedOnly) {
              this.deleteFuelRate();
            } else {
              this.addNewVesselRates(updates);
            }
            this.model.fuelPayeeType = updates.vesselUpdates.fuelPayeeType;
            this.model.fuelPayeeUserId = updates.vesselUpdates.fuelPayeeUserId;
            this.getFuelPayeeUser();
            this.saveVessel.emit();
            break;
          case ScreenType.OPTIONAL_ADD_ON:
            if (updates.deleteAddOn) {
              // delete
              this.addOnDAO
                .deleteById(this.model.id, updates.addOnId)
                .subscribe(({ status }) => {
                  if (status === 200) {
                    this.addOns.splice(idx, 1);
                    this.filterAddOns(this.addOns);
                  } else {
                    this.snackBar.open('Failed to delete add on', null, {
                      duration: 5000,
                      verticalPosition: 'top',
                    });
                  }
                });
            } else if (idx != null) {
              // edit
              this.addOnDAO
                .updateAddOn(this.model.id, updates.vesselUpdates.addOn)
                .subscribe((addOn) => {
                  this.addOns[idx] = addOn;
                  this.filterAddOns(this.addOns);
                });
            } else {
              // create
              this.addOnDAO
                .createAddOn(this.model.id, updates.vesselUpdates.addOn)
                .subscribe((createdAddOn: AddOn) => {
                  this.addOns.push(createdAddOn);
                  this.filterAddOns(this.addOns);
                });
            }
            break;
          case ScreenType.EXTRA_GUEST_FEE:
            if (
              updates.vesselUpdates.addOn.price > 0 &&
              !this.extraGuestAddOn
            ) {
              this.addOnDAO
                .createAddOn(this.model.id, updates.vesselUpdates.addOn)
                .subscribe((createdAddOn: AddOn) => {
                  this.addOns.push(createdAddOn);
                  this.filterAddOns(this.addOns);
                });
            } else if (
              updates.vesselUpdates.addOn.price === 0 &&
              this.extraGuestAddOn
            ) {
              this.addOnDAO
                .deleteById(this.model.id, addOn.id)
                .subscribe(({ status }) => {
                  if (status === 200) {
                    const extraAddOnIdx = this.addOns.findIndex(
                      (x) => x.name === DefinedAddOnType.EXTRA_GUEST_FEE,
                    );
                    this.addOns.splice(extraAddOnIdx, 1);
                    this.filterAddOns(this.addOns);
                  } else {
                    this.snackBar.open('Failed to delete add on', null, {
                      duration: 5000,
                      verticalPosition: 'top',
                    });
                  }
                });
            } else if (this.extraGuestAddOn) {
              this.addOnDAO
                .updateAddOn(this.model.id, updates.vesselUpdates.addOn)
                .subscribe((addOn) => {
                  const extraAddOnIdx = this.addOns.findIndex(
                    (x) => x.name === DefinedAddOnType.EXTRA_GUEST_FEE,
                  );
                  this.addOns[extraAddOnIdx] = addOn;
                  this.filterAddOns(this.addOns);
                });
            }
            break;
        }
      });
    this.subs.push(dialogSub);
  }

  addRemoveCleaning(updates: WhatsIncluded) {
    const veselRateSub = this.vesselRateDAO
      .addRemoveCleaning(this.model.id, updates)
      .subscribe((rates) => {
        this.columnDefs = null;
        this.rowData = [];
        this.addRates(rates, true);
        this.model.vesselRates = rates; // update vesselrates due to id update
      });
    this.subs.push(veselRateSub);
  }

  applyTaxToRates(updates: WhatsIncluded) {
    const veselRateSub = this.vesselRateDAO
      .applyTaxToRates(this.model.id, updates)
      .subscribe((rates) => {
        this.columnDefs = null;
        this.rowData = [];
        this.addRates(rates, true);
      });
    this.subs.push(veselRateSub);
  }

  deleteFuelRate() {
    const veselRateSub = this.vesselRateDAO
      .deleteFuelRate(this.model.id)
      .subscribe((rates) => {
        this.columnDefs = null;
        this.rowData = [];
        this.model.fuelIncluded = false;
        this.addRates(rates, true);
      });
    this.subs.push(veselRateSub);
  }

  addNewVesselRates(updates) {
    const veselRateSub = this.vesselRateDAO
      .createWhatsIncludedRates(this.model.id, updates)
      .subscribe((rates) => {
        this.columnDefs = null;
        this.rowData = [];
        this.addRates(rates, true);
        this.model.vesselRates = rates; // update vesselrates due to id update
      });
    this.subs.push(veselRateSub);
  }

  openBoatListingPage() {
    window.open(this.linkToListingPage, '_blank');
  }

  private createLinkToListingPage() {
    if (!this.model.make) return;
    return `${this.environmentalMediaService.getClientBaseURL()}vessels/yacht-and-boat-rentals/${buildRouteEnding(
      this.model,
    )}`;
  }

  getFuelPayeeUser() {
    const userSub = this.userDao.getUsersForPayouts().subscribe((data) => {
      const payee = data.find((x) => x.id === this.model.fuelPayeeUserId);
      this.fuelPayee = payee ? `${payee.firstName} ${payee.lastName}` : null;
    });
    this.subs.push(userSub);
  }

  createAmountSubtext({
    type = null,
    price = 0,
    unitType = null,
    minQuantity = 0,
    markupPercentage = 0,
  }) {
    const markedupPrice = roundToNearestCent(price * (1 + markupPercentage));
    if (type === DefinedAddOnType.EXTRA_GUEST_FEE) {
      return markedupPrice > 0
        ? `Add $${markedupPrice}/pp after ${minQuantity} guests`
        : 'No charge for extra guests';
    }
    return `$${markedupPrice} ${unitType}`;
  }

  createPayeeSubtext({ type }) {
    if (type === ScreenType.APPLY_TAXES) {
      return this.taxRates
        .map((taxRate) => getRateNameForCustomer(taxRate))
        .join(', ');
    }
  }

  getAddOnByName(name) {
    const index = this.addOns.findIndex((x) => x.name === name);
    return index !== -1 ? index : null;
  }
}
